export default __webpack_public_path__ + "static/media/fl6.f076cba5.png";